(function () {
  'use strict';

  // Open modal on trigger click
  document.querySelectorAll('[data-lr-popup-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.lrPopupTrigger;
      var modal = id ? document.getElementById(id) : null;
      if (modal) modal.setAttribute('data-active', '');
    });
  });

  // Close on close button
  document.querySelectorAll('[data-lr-modal-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = btn.closest('[data-lr-modal]');
      if (modal) modal.removeAttribute('data-active');
    });
  });

  // Close on backdrop click
  document.querySelectorAll('[data-lr-modal]').forEach(function (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.removeAttribute('data-active');
    });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-lr-modal][data-active]').forEach(function (modal) {
        modal.removeAttribute('data-active');
      });
    }
  });
})();
